import React, { useEffect, useState } from "react";
import { Col, Flex, Form, Input, Row, Table } from "antd";
import { HeaderCell } from "../Dashboard/HeaderCell";


export const Preview = ({rows, headers}) => {
  let columns = headers.map(header=>({
	title: header,
	editable: false,
	dataIndex: header,  
	sorter: false,
	align: "left",

  }));
  columns.push({
	  title: 'status',
	  dataIndex: 'validRow',
	  sorter: false,
	  align: "left",
	  render: (_, record) => <span>{record.validRow === true ? 'OK' : record.validRow}</span>

	  
  })
  
  
  const getRowClassName = (record) => {
	return record?.validRow === true ? '' : 'ant-table-row-highlight';
  };

  return (
	<Flex className={""} vertical>
		<Table
			components={{
				header: {
					row: HeaderCell,
				},
			}}
			columns={columns}
			dataSource={rows.slice(0, 10)}
			style={{ marginTop: 10 }}
			scroll={{ x: "100%" }}
			pagination={false}
			rowClassName={getRowClassName}
		/>
	</Flex>
  );
};
